import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M17 13a4 4 0 1 1-.001 8A4 4 0 0 1 17 13m3.706-8.292-16 15.999-1.414-1.414 16-16zm-2.94 10.444a2 2 0 0 0-2.18.434 2 2 0 1 0 2.18-.434M5.47 3.305a4 4 0 1 1 3.06 7.39 4 4 0 0 1-3.06-7.39M7 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }